/* import __COLOCATED_TEMPLATE__ from './fly-menu-item.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import itemProperty from '@customerio/fly-components/utils/item-property';
import { action, computed } from '@ember/object';
/**
  @public
  @class FlyMenuItem
 **/
let FlyMenuItem = (_dec = computed('args.{disabled,item.disabled}'), (_class = class FlyMenuItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "item", null);
  }
  /**
    A flag for whether the dropdown is focused or not.
     @public
    @property isFocused
    @type Boolean
    @default false
  */
  get isFocused() {
    return this.args.focusedItem === this.args.item;
  }

  /**
    A flag for whether the dropdown is selected or not.
     @public
    @property isSelected
    @type Boolean
    @default false
  */
  get isSelected() {
    return this.args.selectedItem === this.args.item;
  }
  get labelProperty() {
    return this.args.labelProperty ?? 'label';
  }

  /**
    The label to display.
     @public
    @property label
    @type String
  */
  get label() {
    return itemProperty(this.args.item, this.labelProperty);
  }

  /**
    A flag for whether the dropdown item is disabled or not.
     @public
    @property disabled
    @type Boolean
  */
  get disabled() {
    return (this.args.disabled ?? false) || (this.args.item.disabled ?? false);
  }
  onClick() {
    if (this.disabled) {
      return;
    }
    this.args.onClick(this.args.item);
  }
  onMouseMove(event) {
    let {
      movementX,
      movementY
    } = event;
    if (movementX === 0 && movementY === 0) {
      // Triggered by scroll, not mouse movement, ignore
      //
      // NB: only Chrome and Firefox currently implement movementX/movementY,
      // so the UI behaviour will be worse on Safari, IE, and Edge.
      //
      // Specifically, if the user scrolls (using keyboard, scroll wheel, or
      // gestures) and doesn't move the mouse, we will still receive a
      // MouseMove event. Since we can't tell that the mouse hasn't actually
      // moved relative to the page, we will still select the item under the
      // cursor, which is not necessarily desirable.
      //
      // This is the best we can do without caching the previous event and
      // doing our own delta.

      return false;
    }
    if (!this.isFocused) {
      this.args.onRequestFocus(this.args.item);
    }
    return true;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "disabled", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "disabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMouseMove", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMouseMove"), _class.prototype)), _class));
export { FlyMenuItem as default };